export const KEY_IDX = '__fea_idx';

export const INVALID_PROJECTED_ANCHOR = -999999;

// an impossible altitude to mark invalid altitude values
export const INVALID_ALTITUDE = new Float32Array([-1E12])[0];

export const PROP_OMBB = 'maptalks_ombb';
